import {
  MousePointer2,
  TrendingUp,
  Minus,
  MoveUpRight,
  Square,
  Circle,
  Spline,
  Type,
  Trash2,
} from 'lucide-react';
import type { ChartDrawingApi } from './useChartDrawing';

interface ToolDef {
  type: string | null;
  label: string;
  Icon: typeof Minus;
}

// Tool-type keys match the registered line-tools-core tools.
const TOOLS: ToolDef[] = [
  { type: null, label: 'Cursor', Icon: MousePointer2 },
  { type: 'TrendLine', label: 'Linha de tendência', Icon: TrendingUp },
  { type: 'HorizontalLine', label: 'Linha horizontal', Icon: Minus },
  { type: 'Ray', label: 'Raio', Icon: MoveUpRight },
  { type: 'Rectangle', label: 'Retângulo', Icon: Square },
  { type: 'Circle', label: 'Círculo', Icon: Circle },
  { type: 'FibRetracement', label: 'Fibonacci', Icon: Spline },
  { type: 'Text', label: 'Texto', Icon: Type },
];

interface Props {
  drawing: ChartDrawingApi;
}

/** Floating vertical drawing toolbar overlaid on the chart. */
export default function ChartDrawingToolbar({ drawing }: Props) {
  const { activeTool, setTool, clearAll } = drawing;

  return (
    <div className="absolute top-2 left-2 z-30 flex flex-col gap-1 rounded-lg border border-border-subtle bg-bg-elevated/95 p-1 shadow-md backdrop-blur">
      {TOOLS.map(({ type, label, Icon }) => {
        const active = activeTool === type;
        return (
          <button
            key={label}
            type="button"
            title={label}
            aria-label={label}
            aria-pressed={active}
            onClick={() => setTool(type)}
            className={`flex h-8 w-8 items-center justify-center rounded-md transition-colors ${
              active
                ? 'bg-accent-primary text-white'
                : 'text-text-secondary hover:bg-bg-subtle hover:text-text-primary'
            }`}
          >
            <Icon className="h-4 w-4" />
          </button>
        );
      })}
      <div className="my-0.5 h-px w-full bg-border-subtle" />
      <button
        type="button"
        title="Limpar tudo"
        aria-label="Limpar todos os desenhos"
        onClick={clearAll}
        className="flex h-8 w-8 items-center justify-center rounded-md text-text-secondary transition-colors hover:bg-red-500/10 hover:text-red-500"
      >
        <Trash2 className="h-4 w-4" />
      </button>
    </div>
  );
}
